<div class="now-tab-bar-container" data-autoselect="true" #tabbarContainer>
  <nav class="now-tab-bar-wrapper">
    <ul class="now-tab-bar" role="tablist">
      <li role="presentation">
        <ng-template
          *ngTemplateOutlet="
            tabItem;
            context: {
              index: 0
            }
          "
        ></ng-template>
      </li>
      <li role="presentation">
        <ng-template
          *ngTemplateOutlet="
            tabItem;
            context: {
              index: 1
            }
          "
        ></ng-template>
      </li>
      <li role="presentation">
        <ng-template
          *ngTemplateOutlet="
            tabItem;
            context: {
              index: 2
            }
          "
        ></ng-template>
      </li>
    </ul>
    <button class="now-tab-bar-prev-btn" type="button" aria-label="zurück"></button>
    <button class="now-tab-bar-next-btn" type="button" aria-label="weiter"></button>
  </nav>
</div>

<ng-template #tabItem let-index="index">
  <a
    role="tab"
    id="tab-{{ index }}"
    [aria-selected]="isTabSelected(index) ? 'true' : 'false'"
    [tabindex]="isTabSelected(index) ? '0' : '-1'"
    [class]="isTabSelected(index) ? 'active' : ''"
    (focus)="setSelectedTab(index)"
    >{{ getTabText(index) }}
  </a>
</ng-template>
